import { useEffect } from 'react';
import { Linking, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import queryString from 'query-string';
import { useFilterStore } from '../store/FilterStore';
import { useUserStore } from '../store/UserStore';
import { navigateFromRoute } from './navigateFromRoute';



export default function AppLinkHandler() {
    const { setSelectedCategory, setSelectedBrand } = useFilterStore();
    const { user } = useUserStore();

    const navigation = useNavigation();

    useEffect(() => {
        const handleDeepLink = async ({ url }) => {
            const cleanedUrl = url.replace('awesometest://', '');
            if (cleanedUrl.startsWith('http')) {
                Linking.openURL(cleanedUrl);
                return;
            }

            const [path, query] = cleanedUrl.split('?');
            const params = queryString.parse(query);

            navigateFromRoute(
                { type: 'internal', url: path, params },
                navigation,
                { setSelectedCategory, setSelectedBrand },
            );
        };

        const getInitialUrl = async () => {
            if (Platform.OS === 'web') return;
            const initialUrl = await Linking.getInitialURL();
            if (initialUrl) {
                handleDeepLink({ url: initialUrl });
            }
        };
        

        if (Platform.OS === 'web') return;

        const subscription = Linking.addEventListener('url', handleDeepLink);

        getInitialUrl();

        return () => {
            subscription.remove();
        };
    }, [navigation]);

    return null;
}
